import clsx from "clsx";
import React from "react";
import { Grid2Props, Box } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

import { SearchField } from "../fields/SearchField";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      gap: theme.spacing(1),
      flexDirection: "column",
    },
  },

  search: {
    backgroundColor: theme.palette.background.paper,
    [theme.breakpoints.up("md")]: {
      maxWidth: 500,
    },
  },

  inputActive: {
    "&.MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: theme.palette.primary.main,
      },
      "&:hover fieldset": {
        borderColor: theme.palette.primary.main,
      },
    },

    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: theme.palette.primary.main,
      },
      "&:hover fieldset": {
        borderColor: theme.palette.primary.main,
      },
    },
  },
}));

export interface HeaderFiltersProps extends Grid2Props {
  query: string;
  searchPlaceholder?: string;
  onChangeQuery?: (query: string) => void;
  defaultValues: {
    query: string;
  };
  selectItem: any;
}

export const LibraryHeaderFilters = (props: HeaderFiltersProps) => {
  const s = useStyles();
  const {
    className,
    query,
    onChangeQuery,
    defaultValues: { query: defaultQuery },
    searchPlaceholder,
    selectItem,
    ...other
  } = props;

  const handleChangeQuery = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      const query = event.currentTarget.value;
      onChangeQuery?.(query);
    },
    [onChangeQuery],
  );

  return (
    <>
      <Box className={clsx(s.root, className)} {...other}>
        <SearchField
          className={clsx(s.search, query !== defaultQuery && s.inputActive)}
          size="small"
          variant="outlined"
          fullWidth
          placeholder={searchPlaceholder}
          value={query}
          onChange={handleChangeQuery}
        />
        {selectItem}
      </Box>
    </>
  );
};
